import React from 'react'
import { FiCalendar, FiUser, FiCreditCard, FiPhone, FiMail } from "react-icons/fi"
import { getStatusClass } from '../../utils/data'
import { useTranslation } from 'react-i18next'
import { BookingTrip } from '../../types'
import {  FaDollarSign } from 'react-icons/fa'
import { Link } from 'react-router-dom'
const TripBookingCards = ({ bookings }: { bookings: BookingTrip[] }) => {
    const { t } = useTranslation()
    return (
        <div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {bookings.map((booking: BookingTrip ) => (
                    <div
                        key={booking.id}
                        className={`bg-white border overflow-hidden rounded-2xl shadow-sm hover:shadow-lg transition p-5 flex flex-col ${booking.state === "Waiting" ? "border border-secondry " : ""
                            }`}
                    >
                        {/* ID + Status */}
                        <div className="flex items-center justify-between mb-4">
                            <h3 className="font-semibold text-gray-800">#{booking.id}</h3>
                            <span
                                className={`px-3 py-1 text-xs rounded-full font-medium ${getStatusClass(
                                    booking.state
                                )}`}
                            >
                                {t(booking.state)}
                            </span>
                        </div>

                        <p className="flex items-center gap-2 text-sm text-gray-600 mb-3">
                            <FiUser /> {t("user")}:{" "}
                            <span className="font-medium">{booking.userName}</span>
                        </p>


                        <div className="flex gap-5 justify-between text-sm text-gray-600 mb-3">

                            <div className=' flex-1 overflow-hidden text-ellipsis'>
                                <p className="flex items-center gap-1 text-gray-500">
                                    <FiMail className="text-gray-400" />
                                    {t("email")}
                                </p>
                                <p className="font-medium" dir='ltr'>
                                    {booking.email}
                                </p>
                            </div>

                            <div className=' flex-1'>
                                <p className="flex items-center gap-1 text-gray-500">
                                    <FiPhone className="text-gray-400" />
                                    {t("phone")}
                                </p>
                                <p className="font-medium">
                                    {booking.phone}
                                </p>
                            </div>
                        </div>
                        {/* Dates */}
                        <div className="flex justify-between text-sm text-gray-600 mb-3">
                            <div>
                                <p className="flex items-center gap-1 text-gray-500">
                                    <FiCalendar /> {t("check-in")}
                                </p>
                                <p className="font-medium">
                                    {new Date(booking.trip.fromDate).toLocaleDateString()}
                                </p>
                            </div>
                            <div>
                                <p className="flex items-center gap-1 text-gray-500">
                                    <FiCalendar /> {t("check-out")}
                                </p>
                                <p className="font-medium">
                                    {new Date(booking.trip.toDate).toLocaleDateString()}
                                </p>
                            </div>
                        </div>
                        <Link 
                        className=' text-textSecond font-medium text-sm'
                        to={`/dashboard/trip-booking-report/${booking.trip.id}`}>
                            {t("trip")} {booking.trip?.fromLocation} {t("to")} {booking.trip?.toLocation}
                        </Link>
                        {/* Total + Payment */}
                        <div className="flex justify-between items-center border-t pt-3 mt-auto">
                            <p className="font-semibold text-gray-800  flex items-center gap-1">
                                <FaDollarSign/> {booking.price.toFixed(2)} {booking.currency}
                            </p>
                            <span className="flex items-center gap-1 text-xs text-gray-500">
                                <FiCreditCard /> {t("payment-method")}: {booking.paymentMethod}
                            </span>
                        </div>
                    </div>
                ))}
            </div>

        </div>
    )
}

export default TripBookingCards